import React from "react";
import Loading from "../../Loading";
import Random from "../../Random";


const Drawing = ({resultLeft, config}) => {

    return <div className="d-flex justify-content-end w-50 h-100">
        <table className="bkqmiennam mt w-100 h-100">
            <tbody>
            {resultLeft?.map((res, j) => {
                const hlBG = config.hlIndex.includes(j);
                const style = {
                    background: hlBG ? config.hlBG : config.background
                }
                return <tr style={style} className={`row-${j}`} key={j}>
                    {res.items.map((list, i) => {
                        const style = config.row[`row_${j}`]
                        return <td align="middle" key={`${j}_${i}`}>
                            {list.map((num, index) => {
                                if (num.includes("*")) {
                                    return <div key={index}>
                                        <Loading style={style?.loading ?? config?.loading}
                                                 className="loading-res"
                                                 sizeDigit={num.length}/>
                                    </div>
                                }
                                if (num.includes("?")) {
                                    let randomSt = style?.random ? {
                                        ...style.random,
                                        background: config.random.background
                                    } : config.random
                                    return <div key={index}>
                                        <Random className="random-res" style={randomSt} sizeDigit={num.length}/>
                                    </div>
                                }
                                return <div style={{...style?.normal}}
                                            key={index}>{num}</div>
                            })}
                        </td>
                    })}
                </tr>
            })}
            </tbody>
        </table>
    </div>
}

export default Drawing;